const topics = [
  { tag: '顶流塌房', heat: '980万', hot: true, desc: '当红艺人私生活争议持续发酵' },
  { tag: '网红翻车', heat: '760万', hot: true, desc: '知名主播带货虚假宣传被实锤' },
  { tag: '恋情实锤', heat: '650万', hot: true, desc: '圈内情侣同框视频全网首曝' },
  { tag: '综艺内幕', heat: '520万', hot: false, desc: '选秀节目暗箱操作录音流出' },
  { tag: '商业纠纷', heat: '480万', hot: false, desc: '顶流解约风波背后资本博弈' },
  { tag: '片场秘闻', heat: '410万', hot: false, desc: '热播剧组拍摄期间惊人爆料' },
  { tag: '税务风波', heat: '380万', hot: false, desc: '多位艺人被约谈最新进展' },
  { tag: '豪门恩怨', heat: '350万', hot: false, desc: '知名企业家族财产争夺升级' },
  { tag: '海外爆料', heat: '290万', hot: false, desc: '海外留学生爆料国内娱乐圈' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            全网吃瓜群众都在关注的话题标签，点击追踪最新51吃瓜黑料视频动态
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200/50 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center text-lg font-heading ${
                topic.hot
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                    #{topic.tag}
                  </h3>
                  {topic.hot && (
                    <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
                      HOT
                    </span>
                  )}
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mb-2 line-clamp-1">
                  {topic.desc}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-fire-line text-primary-400"></i>
                  <span>{topic.heat} 热度</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}